import PropTypes from 'prop-types';

const BreadcrumbRoot = ({ children }) => (
  <nav aria-label="breadcrumb">
    <ol className="flex w-full flex-row flex-nowrap items-center overflow-x-auto py-4 scrollbar-none md:overflow-hidden lg:py-6">
      {children}
    </ol>
  </nav>
);

BreadcrumbRoot.propTypes = {
  /**
   * Components to be rendered inside component
   */
  children: PropTypes.node.isRequired,
};

export default BreadcrumbRoot;
